const profilePaperPadding = 2.5;

export default profilePaperPadding;
